/**
 * Terminal — client-side exports
 *
 * Embeddable agent CLI terminal component.
 */

export { AgentTerminal, type AgentTerminalProps } from "./AgentTerminal.js";
